import { AnoBase } from './ano-base.model';
import { TipoInstituicao } from './tipo-instituicao.model';

export class Instituicao {
  id: number;
  idPessoa: number;
  nomeInstituicao: string;
  tipoInstituicao: TipoInstituicao;
  tipoCapital: number;
  situacaoAtiva: number;
  codigo: number;
  cnpj: string;
  anoBase: AnoBase;
}
